const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000057865099660653502580000017167058325643903905_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M5.5,0.3H0.9c-0.3,0-0.6,0.2-0.7,0.6c0,0,0,0.1,0,0.1v4.5c0,0.3,0.2,0.7,0.6,0.7c0,0,0.1,0,0.1,0 h4.6c0.3,0,0.6-0.2,0.7-0.6c0,0,0-0.1,0-0.1V1c0-0.3-0.2-0.7-0.6-0.7C5.6,0.3,5.5,0.3,5.5,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M14.9,5.5V1c0-0.3-0.2-0.7-0.6-0.7c0,0-0.1,0-0.1,0H9.7C9.4,0.3,9.1,0.5,9,0.9C9,0.9,9,1,9,1v4.5 c0,0.3,0.2,0.7,0.6,0.7c0,0,0.1,0,0.1,0h4.6c0.3,0,0.6-0.2,0.7-0.6C14.9,5.6,14.9,5.6,14.9,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M17.8,1v4.5c0,0.3,0.2,0.7,0.6,0.7c0,0,0.1,0,0.1,0h4.6c0.3,0,0.6-0.2,0.7-0.6c0,0,0-0.1,0-0.1V1 c0-0.3-0.2-0.7-0.6-0.7c0,0-0.1,0-0.1,0h-4.5C18.2,0.3,17.8,0.5,17.8,1C17.8,0.9,17.8,1,17.8,1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M1.2,9.1h21.7c0.5,0,0.9,0.4,0.9,0.9v12.9c0,0.5-0.4,0.9-0.9,0.9H1.2c-0.5,0-0.9-0.4-0.9-0.9V10 C0.2,9.5,0.7,9.1,1.2,9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerView);
export default __webpack_public_path__ + "static/media/speakerView.30466190b8d0b9da479a53d43fc686ce.svg";
export { ForwardRef as ReactComponent };